export default __webpack_public_path__ + "static/media/LoginImage.823f1026.png";